// src/components/TopNavBar.js
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/authSlice"; // Adjust the path as needed
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../Styles/Common.css";

const TopNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Retrieve user info from localStorage (assumed to be stored as JSON)
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    user = null;
  }
  // Use user's role if available; otherwise default to "Super Admin"
  const role = user && user.role ? user.role : "Super Admin";

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleProfile = () => {
    // Navigate to profile page (implement as needed)
    navigate("/profile");
    setDropdownOpen(false);
  };

  const handleAccount = () => {
    // Navigate to account settings page (implement as needed)
    navigate("/account");
    setDropdownOpen(false);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div
      className="top-bar"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0rem 1rem",
        backgroundColor: "#f5f5f5",
      }}
    >
      <h1 className="title">IMS : {role}&nbsp;</h1>
      <div style={{ position: "relative" }}>
        <i
          className="fa fa-bars"
          style={{ marginRight:"0.1rem", fontSize: "0.9rem", cursor: "pointer", color:'#666' }}
          onClick={toggleDropdown}
        ></i>
        {dropdownOpen && (
          <div
            className="dropdown-menu"
            style={{
              position: "absolute",
              right: 0,
              top: "100%",
              backgroundColor: "#fff",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
              zIndex: 1000,
              minWidth: "150px",
            }}
          >
            <div
              className="dropdown-item"
              onClick={handleProfile}
              style={{ padding: "0.5rem 1rem", cursor: "pointer" }}
            >
              Profile
            </div>
            <div
              className="dropdown-item"
              onClick={handleLogout}
              style={{ padding: "0.5rem 1rem", cursor: "pointer" }}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopNavBar;
